import {
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnInit,
  ViewChild, OnDestroy
} from '@angular/core';
import * as _ from 'lodash';


import * as moment from 'moment';

import { interval } from 'rxjs';
import { getLastLiveLocation, getTravelsLocations } from '../api/livelocation';
import { getTravelsApi } from '../api/tripline';

declare var google;
declare var L: any;

const generateColor = (num: number) => {
	const arrayOfColors = ['blue', 'red', 'orange', 'green', 'violet', 'black'];
	var item = arrayOfColors[num];
	return item;
};

@Component({
  selector: 'app-live-location',
  templateUrl: './live-location.component.html',
  styleUrls: ['./live-location.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LiveLocationComponent implements OnInit,OnDestroy {
  colorNumber: number = 0;



  routerOnDeactivate() {
    clearInterval(this.timer);
  }

  ngOnDestroy(): void {
    this.routerOnDeactivate()
        console.log('kill')
    }
  data = [];
  timer;





  nameSpace = localStorage.getItem('nameSpace');
  token = localStorage.getItem('currentUser');
  headers = {'x-name-space': this.nameSpace , 'Authorization': this.token};
  map: any;
  @ViewChild('map') mapElement: ElementRef;

  show = false;
  location = [];


  layerGroup: any;

  index = 0;

  markerLayer = new L.LayerGroup();
  polyLineLayer = new L.LayerGroup();

  public connection;

  history = false;
  repLiveLocation = [];




  events = [];
  snappedPoints = [];

  mapVisitLocation: any;
  @ViewChild('map') mapVisitElement: ElementRef;





  zoom = 1;

  hideRep = [];

  historyLoading = false;
  noHistoryFound = false;
  noLiveLocationData = false;
  pulsingIcon = L.icon({iconUrl:"../../assets/images/icons/bus1.png",iconSize: [50, 50]});
  loadLiveLocation = false;


  selectedClient = false;
  public lat: Number =  31.963158;
  public lng: Number = 35.930359;
  public origin = {lat: 0, lng: 0};
  public destination = {lat: 0, lng: 0};
  public waypoints = [];

  // constructor(private cd: ChangeDetectorRef) {

  //   this.timer=interval(1000).subscribe(
  //     (value: number) => {
  //       if (!this.history) {
  //     this.getLastLiveLocation();
  //       }

  //     },
  //     (error: any) => {
  //       console.log('error');
  //     },
  //     () => {
  //       console.log('observable completed !');
  //     }
  //   );


  // }

  removeLayer() {
   this.markerLayer.clearLayers();
   this.polyLineLayer.clearLayers();
    // this.cd.detectChanges();

  }
  generateMarker(locations) {

    this.removeLayer();
    const markers = [];
    locations.map(data => {
      data.location.map(location => {
        if (location.user_name) {

          let busMarker = new L.marker([location.lat, location.lng], {icon: this.pulsingIcon, title: location.user_name});
          busMarker.addTo(this.map);
          busMarker.bindPopup(`
            ${data.travel.travel_start_name} - ${data.travel.travel_end_name}<br/>
            Driver: ${location.user_name}<br/>
            Bus: ${location.bus_identity}<br/>
            Students on bus: ${location.no_of_students_on_bus}
          `)
          // markers.push(L.marker([location.lat, location.lng], {icon: this.pulsingIcon}).bindPopup(location.user_name))
          // this.add_map_point(location.lat,location.lng)
        }
      })
    });




    // this.markers = L.layerGroup(markers);
    // this.map.panTo(new L.LatLng(locations[0].lat, locations[0].lng));
    // L.control.layers(this.markers).addTo(this.map);
    // this.cd.detectChanges();

  }





  ngOnInit() {




    this.getTravels();
    this.getLastLiveLocation();
    this.generateMap();

  }



  generateMap() {
    this.map = L.map('map', {
      layers: [this.markerLayer, this.polyLineLayer]

    }).setView([this.lat, this.lng], 8);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: 'Map data &copy; <a href="https://tracllo.com">Tracllo',
      maxZoom: 18,
    }).addTo(this.map);
    const layerGroup = L.layerGroup().addTo(this.map);
    this.map.addControl(new L.Control.Fullscreen());

    // events are fired when entering or exiting fullscreen.
    // this.map.on('enterFullscreen', function() {
    //   console.log('entered fullscreen');
    // });

    // this.map.on('exitFullscreen', function() {
    //   console.log('exited fullscreen');
    // });
    this.map.addLayer(this.markerLayer);
    this.map.addLayer(this.polyLineLayer);

  }
  
  async getTravels() {
    const result = await getTravelsApi();
    let markers = [];
    let bounds;
    
    if (result) {
        result.data.data.map(way => {
          const markerArr = [];
          const color = generateColor(this.colorNumber);
          this.colorNumber++;
          if (this.colorNumber > 5) {
            this.colorNumber = 0;
          };
          way.way_points.map(point => {
            markerArr.push([point.lat, point.lng]);
            let pointMarker = new L.marker(
              [point.lat, point.lng],
              {icon: L.icon({iconUrl: `https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-${color}.png`, iconSize: [25, 41]}),
              title: point.label}
            );
            pointMarker.bindPopup(`${way.travel_start_name} - ${way.travel_end_name}<br/>${point.label}`)
            pointMarker.addTo(this.map);
            markers.push(pointMarker);
          })
          console.log(markerArr);
          if (markerArr && markerArr.length > 0) {
            var polyline = L.polyline(markerArr, { color: color }).addTo(
              this.map
            );
            console.log(polyline);
          }
  
          bounds = L.latLngBounds(
            markers.map((marker) => {
              console.log(marker.getLatLng());
              return marker.getLatLng();
            })
          );
        })
        this.map.fitBounds(bounds);
    }

  }


  async getLastLiveLocation() {
    this.repLiveLocation = []
    this.history = false;
    this.noLiveLocationData = false;
    this.loadLiveLocation = true;

    // @ts-ignore
    getTravelsLocations(this.headers).then(async res => {
      console.log(res.data)
      this.waypoints=[]
      this.repLiveLocation = []
      this.repLiveLocation = res.data.data;





      if (this.repLiveLocation.length == 0) {
        this.noLiveLocationData = true;
        this.loadLiveLocation = false;
      } else {

        if (!this.selectedClient) {
          this.lat = this.repLiveLocation[0].lat;
          this.lng = this.repLiveLocation[0].lng;
        }
        this.loadLiveLocation = false;
      }
      this.zoom = 12;
      // this.live=this.live.reverse()


      // this.origin = {lat: this.repLiveLocation[0].lat, lng: this.repLiveLocation[0].lng}
      // this.destination = {lat: this.repLiveLocation[this.repLiveLocation.length - 1].lat, lng: this.repLiveLocation[this.repLiveLocation.length - 1].lng}
      //
      // this.repLiveLocation.map(data => {
        // this.add_map_point(location.lat,location.lng)
        // this.waypoints.push(data.travel);
      // });

      this.generateMarker(this.repLiveLocation);
      this.show = true;
      // if(!this.cd['destroyed']) {
      //   this.cd.detectChanges();
      // }


    }).catch(err => console.log(err));


  }


  checkToday(time) {
    console.log(moment(time).set({h: 0, s: 0, m: 0}).isBefore(moment().set({h: 0, s: 0, m: 0})));
    return moment().format('YYYY-MM-DD') == moment(time).format('YYYY-MM-DD');
  }



  hideMarker(checked, rep_id, lat, lng) {

    if (checked) {
     const value = [];

      for (let i = 0; i < this.hideRep.length; i++) {

        if (this.hideRep[i] != rep_id) {
          value.push(rep_id);
        }

      }
      this.hideRep = value;

      console.log(this.hideRep);
    } else {
      this.hideRep.push(rep_id);


    }


    // if(!this.cd['destroyed']) {
    //   this.cd.detectChanges();
    // }
    console.log(checked);
  }


  goToLocation(lat, lng) {
    console.log(lat, lng);
    this.lat = lat;
    this.lng = lng;
    this.map.panTo(new L.LatLng(lat, lng));

    this.selectedClient = true;
    this.zoom = 20;
    // if(!this.cd['destroyed']) {
    //   this.cd.detectChanges();
    // }
  }






}